<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectAllDataNew"
            ></v-checkbox>
          </div>
        </template>
        <span>Select All</span>
      </v-tooltip>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.sourceOnboarding"
        :items="listSourceOnboardingFillMid"
        label="Source Onboarding"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.merchantName"
        label="Nama Merchant"
        type="text"
        @change="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.referenceNumber"
        label="Reference No"
        type="text"
        @change="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.areaCode"
        label="Kode Wilayah"
        type="text"
        @change="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-dialog
        ref="dateStartPopup"
        v-model="dateStartPopup"
        :return-value.sync="searchData.createdDate"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            id="dateRangeText"
            readonly
            v-bind="attrs"
            v-on="on"
            v-model="dateRangeText"
            label="Tanggal Pengajuan"
            hide-details="true"
            dense
          />
        </template>
        <v-date-picker v-model="searchData.createdDate" scrollable range>
          <v-spacer />
          <v-btn text color="primary" @click="dateStartPopup = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="
              () => {
                checkRangeDate(searchData.createdDate);
                $refs.dateStartPopup.save(searchData.createdDate);
                getData();
              }
            "
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
export default {
  props: ['search', 'dataList', 'selectAllData', 'selectedData'],
  data: () => ({
    startDatetime: '',
    dateStartPopup: false,
    listSourceOnboardingFillMid: [
      { value: '2', text: 'BNI Merchant' },
      { value: '3', text: 'BNI Move' },
    ],
  }),
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    dateRangeText() {
      return this.searchData.createdDate.join(' ~ ');
    },
    selectAllDataNew: {
      get() {
        return this.selectAllData;
      },
      set(val) {
        this.selectAll(val);
        this.$emit('selectAllDataParent', val);
      },
    },
  },

  methods: {
    checkRangeDate(date) {
      date.sort();
      if (date.length == 1) {
        date.push(date[0]);
      }
    },
    getData() {
      this.$emit('getDataParent');
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.dataList.map((val) => val.id);

        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );

        if (status) {
          this.$emit('selectedDataParent', this.selectedData.concat(filtered));
        } else {
          const newSelected = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
          this.$emit('selectedDataParent', newSelected);
        }
      });
    },
  },
};
</script>
